import React, { useRef } from "react"

const ContentDistancer = ({ height = "h-20" }) => {
  return (
    <div 
      className="hidden xl:block 2xl:hidden w-[130px]" 
      style={{ height }}
    />
  )
}

export default ContentDistancer